// Kohteen pisteen asetus paikan päällä GPS:llä (PoiPlacePanel, ylläpidon "Lisää kohde").
//
// Puhtaat apufunktiot: GPS-tuloksen arviointi ja viestit. Itse paikannus on lib/location.js:ssä (currentFix).
// Raja: tunnistusalue on vähintään 25 m, joten yli 30 m:n paikannusvirhe voi jo siirtää pisteen
// väärälle puolelle rakennusta tai tietä. Heikosta tuloksesta huomautetaan, mutta sitä ei estetä:
// metsässä tai rakennusten välissä parempaa ei aina saa, ja tähtäin on aina siirrettävissä käsin.

import { distanceM } from "./geo.js";

/** Tarkkuus (m), jota parempi tulos kelpaa huomautuksetta. */
export const GOOD_ACCURACY_M = 30;

/** Käyttäjälle näytettävä rivi paikannuksen tuloksesta: { text, poor }. */
export function fixMessage(accuracy, fix = null) {
  if (fix?.stale) {
    const age = fix.ageS == null ? "tuntemattoman ikäistä" : `${fix.ageS} s vanhaa`;
    return {
      text: `Tuoretta sijaintia ei saatu, joten käytettiin ${age} sijaintia. Se ei kelpaa paikan päällä tehdyksi tarkistukseksi: piste tallentuu karttatarkistettuna. Hae sijainti uudelleen paikan päällä.`,
      poor: true,
    };
  }
  if (accuracy == null || !Number.isFinite(accuracy)) {
    return { text: "Sijainti haettu. Tarkkuutta ei tiedetä, joten tarkista tähtäimen paikka kartalta.", poor: true };
  }
  const m = Math.round(accuracy);
  if (accuracy > GOOD_ACCURACY_M) {
    return {
      text: `Sijainti haettu, mutta tarkkuus on heikko (±${m} m). Odota hetki taivaan alla ja hae uudelleen, tai tarkista paikka kartalta.`,
      poor: true,
    };
  }
  return { text: `Sijainti haettu, tarkkuus ±${m} m.`, poor: false };
}

/**
 * Tallennettava tarkistustapa. GPS:llä paikan päällä haettu piste on maastotarkistettu, kunhan tähtäin
 * on yhä GPS-pisteen lähellä (`maxDriftM`); jos käyttäjä on siirtänyt tähtäintä kauemmas, piste on
 * karttatarkistettu, vaikka GPS-nappia on painettu. Ilman GPS-hakua käytetään valittua arvoa.
 */
export function placementVerification(selected, fix, center, maxDriftM = 15) {
  if (fix?.stale && selected === "field_checked") return "map_checked"; // vanha sijainti ei ole maastotarkistus
  if (fix && selected === "field_checked" && distanceM(fix.lat, fix.lon, center.lat, center.lng) > maxDriftM) return "map_checked";
  return selected;
}
